import { render, staticRenderFns } from "./ForwardConfirm.vue?vue&type=template&id=180e3e14&"
import script from "./ForwardConfirm.vue?vue&type=script&lang=js&"
export * from "./ForwardConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports